import React from 'react';
import { Form, FormikProps, Field, withFormik, FormikBag } from 'formik';
import {
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  CardHeader,
  Row,
} from 'reactstrap';
import SubmitButtonWithLoader from 'app/components/common/SubmitButtonWithLoader';
import i18next from 'i18next';

export type AddCompanyFormValues = {
  name: string;
  nip: string;
  address: string;
  bank_account: string;
  representer_name: string;
  representer_phone: string;
  signed_at: string;
};

interface AddCompanyFormOwnProps {
  onAddCompany: (values: AddCompanyFormValues) => void;
}

type AddCompanyFormProps = AddCompanyFormOwnProps &
  FormikProps<AddCompanyFormValues>;

const AddCompanyFormWithoutFormik: React.FC<AddCompanyFormProps> = (props) => {
  const { isSubmitting } = props;
  return (
    <Card>
      <CardHeader>{i18next.t('companies.add-company-title')}</CardHeader>
      <CardBody>
        <Form>
          <Row className="mx-0 d-flex flex-wrap">
            <FormGroup className="col min-w-200">
              <Label>{i18next.t('companies.company-name')}</Label>
              <Field as={Input} name="name" placeholder={i18next.t('companies.company-name-placeholder')} />
            </FormGroup>
            <FormGroup className="col min-w-200">
              <Label>{i18next.t('companies.nip')}</Label>
              <Field as={Input} name="nip" placeholder="np. 1234567890" />
            </FormGroup>
            <FormGroup className="col-12">
              <Label>{i18next.t('companies.address')}</Label>
              <Field as={Input} name="address" placeholder={i18next.t('companies.address-placeholder')} />
            </FormGroup>
            <FormGroup className="col min-w-200">
              <Label>{i18next.t('companies.bank-account')}</Label>
              <Field as={Input} name="bank_account" placeholder="PL 12 3456 7890..." />
            </FormGroup>
            <FormGroup className="col min-w-200">
              <Label>{i18next.t('companies.representer-name')}</Label>
              <Field as={Input} name="representer_name" placeholder="Jan Kowalski" />
            </FormGroup>
            <FormGroup className="col min-w-200">
              <Label>{i18next.t('companies.representer-phone')}</Label>
              <Field as={Input} name="representer_phone" placeholder="+48 123 456 789" />
            </FormGroup>
            <FormGroup className="col min-w-200">
              <Label>{i18next.t('companies.signed-at')}</Label>
              <Field as={Input} name="signed_at" type="date" />
            </FormGroup>
          </Row>
          <FormGroup className="col-12">
            <SubmitButtonWithLoader
              label={i18next.t('companies.add-company-title')}
              loading={isSubmitting}
            />
          </FormGroup>
        </Form>
      </CardBody>
    </Card>
  );
};

const AddCompanyForm = withFormik<AddCompanyFormOwnProps, AddCompanyFormValues>({
  mapPropsToValues: () => ({
    name: '',
    nip: '',
    address: '',
    bank_account: '',
    representer_name: '',
    representer_phone: '',
    signed_at: '',
  }),
  handleSubmit: (
    values: AddCompanyFormValues,
    { props, setSubmitting }: FormikBag<AddCompanyFormOwnProps, AddCompanyFormValues>
  ) => {
    props.onAddCompany(values);
    setSubmitting(false);
  },
})(AddCompanyFormWithoutFormik);

export default AddCompanyForm;
